import { Button, StepIndicator } from '@hausgold/designsystem';
import { ArrowLeftDrop, ArrowRightDrop } from '@hausgold/designsystem/icons';
import { useFormikContext } from 'formik';
import { STEP_START, FIELD_TYPE_ADDRESS } from '../../utils/CONSTANTS.js';
import { ApiContext, WizardContext } from '../../utils/contexts.js';
import analyticsTrack from '../../utils/tracking.js';
import { keys } from 'lodash-es';
import PropTypes from 'prop-types';
import { useContext } from 'react';
import { getNextStepKey, getNextStepPosition, getPreviousStepKey, getBackButtonText, getNextButtonText } from '../../services/models/dialog.js';
import { jsx } from '@emotion/react';
var NavigationButtons = function NavigationButtons(_ref) {
  var totalSteps = _ref.totalSteps,
    currentStepIndex = _ref.currentStepIndex,
    stepKey = _ref.stepKey,
    stepType = _ref.stepType;
  var _useContext = useContext(ApiContext),
    data = _useContext.data;
  var _useContext2 = useContext(WizardContext),
    setCurrentStep = _useContext2.setCurrentStep,
    currentStep = _useContext2.currentStep,
    currentLine = _useContext2.currentLine,
    position = _useContext2.position,
    _useContext2$componen = _useContext2.components,
    NavigationButtonsLayoutContainer = _useContext2$componen.NavigationButtonsLayoutContainer,
    CustomNavigationButtons = _useContext2$componen.CustomNavigationButtons,
    dialogId = _useContext2.dialogId,
    recruiterId = _useContext2.recruiterId,
    leadId = _useContext2.leadId;
  var formikContext = useFormikContext();
  var nextStepKey = getNextStepKey(data, currentLine, currentStep);
  var nextStepPosition = getNextStepPosition(data, currentLine, currentStep);
  var previousStepKey = getPreviousStepKey(data, currentLine, currentStep);

  // Trigger field errors if user clicks on "weiter"
  var touchCurrentFields = function touchCurrentFields() {
    // As address is a "flat object" all its fields must be touched separately.
    if (stepType === FIELD_TYPE_ADDRESS) {
      formikContext.setFieldTouched("".concat(stepKey, "_zip"), true, true);
      formikContext.setFieldTouched("".concat(stepKey, "_street"), true, true);
      formikContext.setFieldTouched("".concat(stepKey, "_city"), true, true);

      // Normal fields handling
    } else {
      formikContext.setFieldTouched(stepKey, true, true);
    }
  };

  // Move to previous step
  var handlePreviousButtonClick = function handlePreviousButtonClick() {
    // If we are on first step go back to start
    if (!previousStepKey) return setCurrentStep(STEP_START);
    // Else go back tp previous
    return setCurrentStep(previousStepKey);
  };

  // Handle all checks and tracking events and move to next step
  var handleNextButtonClick = function handleNextButtonClick(event) {
    touchCurrentFields();
    formikContext.validateForm();

    // Regex matches the currentStep (strict) or currentStep with underscore attachment like currentStep_street.
    var regex = new RegExp("".concat(currentStep, "(_.+)?"));

    // Check if all current fields are set. If not stop and stay on current step
    if (keys(formikContext.errors).some(function (errorField) {
      return regex.test(errorField);
    })) {
      event.preventDefault();
      return;
    }

    // Go to next step.
    // If no step is left the final navigation is done by <Formik onSubmit/> located some files up.
    if (nextStepKey) {
      analyticsTrack({
        event: 'Formwizard Interacted',
        params: {
          dialog_id: dialogId,
          lead_id: leadId,
          recruiter_id: recruiterId,
          label: getNextButtonText(data),
          step: "".concat(currentLine, "-clickto_step").concat(nextStepPosition, "_").concat(nextStepKey)
        }
      });
      setCurrentStep(nextStepKey);
    }
  };

  // Use custom renderer instead of origin if present
  if (CustomNavigationButtons) {
    return jsx(CustomNavigationButtons, {
      totalSteps: totalSteps,
      currentStepIndex: currentStepIndex,
      nextStepKey: nextStepKey,
      handlePreviousButtonClick: handlePreviousButtonClick,
      handleNextButtonClick: handleNextButtonClick
    });
  }

  /**
   * Positon based styles
   */
  var buttonMargin = {
    base: 1,
    sm: null,
    md: 4
  };
  var buttonPaddingX = {
    base: 3.5,
    sm: 4,
    md: 10
  };
  var buttonPaddingY = {
    base: 2.5,
    sm: 3
  };
  var iconMargin = {
    base: 1.5,
    md: 2.5
  };
  var indicatorMarginX = {
    base: 2.5,
    sm: 3,
    md: 4
  };
  if (position === 'right' || position === 'top') {
    buttonMargin = {};
    buttonPaddingX = {};
    buttonPaddingY = {};
    iconMargin = {
      base: 1
    };
    indicatorMarginX = {
      base: 2.5
    };
  }
  return jsx(NavigationButtonsLayoutContainer, null, jsx(Button, {
    variant: "muted",
    as: "a",
    className: "back",
    mr: buttonMargin,
    px: buttonPaddingX,
    py: buttonPaddingY,
    onClick: handlePreviousButtonClick
  }, jsx(ArrowLeftDrop, {
    boxSize: 2.5,
    mr: iconMargin
  }), getBackButtonText(data)), jsx(StepIndicator, {
    colorScheme: "red",
    mx: indicatorMarginX,
    flexGrow: "1",
    alignItems: "center",
    totalSteps: totalSteps,
    currentStep: currentStepIndex + 1
  }), jsx(Button, {
    variant: "primary",
    as: nextStepKey ? 'a' : 'button',
    type: nextStepKey ? null : 'submit',
    className: "next",
    ml: nextStepKey ? buttonMargin : null,
    px: buttonPaddingX,
    py: buttonPaddingY,
    onClick: handleNextButtonClick
  }, getNextButtonText(data), jsx(ArrowRightDrop, {
    boxSize: 2.5,
    ml: iconMargin
  })));
};
NavigationButtons.propTypes = {
  totalSteps: PropTypes.number.isRequired,
  currentStepIndex: PropTypes.number.isRequired,
  stepKey: PropTypes.string.isRequired,
  stepType: PropTypes.string.isRequired
};
export { NavigationButtons as default };